export const getErrors = state => state.errorList;
export const getFatalError = state => state.fatalError;



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/errors/getters.js